export default __webpack_public_path__ + "static/media/checkbox_white.16a13db7.svg";